<script>
import { mapGetters, mapActions } from "vuex";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  setup () {
    return { v$: useVuelidate() }
  },
  computed: {
    ...mapGetters("auth", { getCurrentOrganisation: "getCurrentOrganisation" }),

    customer_group: {
      get() {
        return {
          id: this.id,
          archived: this.archived,
          is_parent: this.is_parent,
          name: this.name,
          organisation: this.getCurrentOrganisation.id,
          parent: this.parent,

          created_at: this.created_at,
          created_by: this.created_by,
          edited_at: this.edited_at,
          edited_by: this.edited_by,
        };
      },
      set(value) {
        //this.id = value.id
        this.archived = value.archived ?? this.archived;
        this.is_parent = value.is_parent ?? this.is_parent;
        this.name = value.name ?? this.name;
        this.organisation = value.organisation ?? this.organisation;
        this.parent = value.parent ?? this.parent;

        this.created_at = value.created_at ?? this.created_at;
        this.created_by = value.created_by ?? this.created_by;
        this.edited_at = value.edited_at ?? this.edited_at;
        this.edited_by = value.edited_by ?? this.edited_by;
      },
    },
  },
  data() {
    return {
      // id: null,
      archived: false,
      is_parent: true,
      name: null,
      organisation: null,
      parent: null,

      created_at: null,
      created_by: null,
      edited_at: null,
      edited_by: null,

      modelName: "Customer Group",
    };
  },
  methods: {
    ...mapActions("customerGroups", ["fetchCustomerGroup"]),
    ...mapActions("application", ["setIsModalLoading"]),

    async initialize() {
      this.setIsModalLoading(true);
        try {
          this.parent = null;
          if (this.id) {
            await this.fetchCustomerGroup({
              organisation: this.getCurrentOrganisation.id,
              id: this.id,
            }).then((res) => {
              this.customer_group = res.data;
            }).catch((error) => {});
          } else if (this.value) {
            this.customer_group = this.value;
          } else {
            this.archived = false;
            this.is_parent = true;
            this.name = this.newDetails?.name || null;
            this.organisation = null;
            this.parent = null;
          }
        } finally {
          this.setIsModalLoading(false);
        }
    },
  },
  mounted() {
    this.initialize();
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default(rawProps) {
        return null;
      },
    },
    newDetails: {
      type: Object,
      default(rawProps) {
        return null;
      },
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.customer_group = newVal;
      },
      deep: true
    },
    customer_group() {
      this.$emit("input", this.customer_group);
    },
  },
  validations: {
    name: { required },
  },
};
</script>

<template></template>
